import {React, useEffect, useState} from 'react';
import {DataGridPro} from "@mui/x-data-grid-pro";
import {contractsColumns} from "../data/DatatableColumns";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import {csCZ} from "@mui/x-data-grid/locales";

function Contracts({data}) {
  const [rows, setRows] = useState([]);


  useEffect(() => {
    if (data && data.report) generateRows()
  }, [data]);


  const generateRows = () => {
    let rows = [];
    data.report.contractList.forEach((contract) => {

      let newCostAssumption = 0;
      let newScope = 0;
      let realized = 0;

      contract.userValueList.forEach((userValue) => {
        userValue.businessMonthAssumptionList.forEach((assumption) => {
          newCostAssumption += assumption.value || 0;
        })

        userValue.businessMonthScopeList.forEach((scope) => {
          newScope += scope.value || 0;
        })
      })

      data.report.receivedInvoiceList.forEach((invoice) => {
        if (invoice.contract === contract.code) {
          realized += invoice.actualPayment;
        }
      })
      rows.push({
        id: contract.code,
        code: contract.code,
        name: contract.description,
        contractNumber: contract.contractNumber,
        startDate: contract.startDate,
        endDate: contract.endDate,
        costAssumption: contract.costAssumption,
        scope: contract.scope,
        newCostAssumption: newCostAssumption,
        newScope: newScope,
        realized: realized,
        remaining: newScope - realized,
      })
      setRows(rows);
      console.log("rows", rows);
    })
  }

  return (
    <Paper>
      <Typography
        sx={{
          paddingLeft: 2,
          paddingTop: 1.7,
          paddingBottom: 1.7,
          fontWeight: 'bold',
          backgroundColor: 'white',
          position: 'sticky',
          left: 0,
          fontSize: "0.85rem",
          height: '45px',
        }}
      >
        Zakázky
      </Typography>
      <DataGridPro
        columns={contractsColumns()}
        rows={rows}
        hideFooter
        localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
        getCellClassName={(params) => {
          if (params.value < 0) {
            return 'negative'
          }
        }}
        sx={{
          height: "77vh",
          '&.MuiDataGrid-root': {
            borderRadius: '0px',
            borderLeft: 'none',
            borderRight: 'none',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold', overflow: 'visible'
          },
          '& .negative': {
            color: 'red'
          }

        }}/>
    </Paper>
  );
}

export default Contracts;